import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DepartmentAPI from '../../../src/api/scheduleAssignment/api-dept-schedule-assignment';

export const fetchDepartments = createAsyncThunk('department/fetch', async (_, thunkAPI) => {
  try {
    const res = await DepartmentAPI.getAll();
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const addDepartment = createAsyncThunk('department/add', async (payload, thunkAPI) => {
  try {
    const res = await DepartmentAPI.add(payload);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateDepartment = createAsyncThunk('department/update', async (payload, thunkAPI) => {
  try {
    const res = await DepartmentAPI.update(payload.id, payload);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteDepartment = createAsyncThunk('department/delete', async (ids, thunkAPI) => {
  try {
    await DepartmentAPI.delete(ids);
    return ids;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const departmentSlice = createSlice({
  name: 'department',
  initialState: { list: [], loading: false, error: '' },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (s) => { s.loading = true; s.error = ''; })
      .addCase(fetchDepartments.fulfilled, (s, a) => { s.loading = false; s.list = [...a.payload]; })
      .addCase(fetchDepartments.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(addDepartment.fulfilled, (s, a) => { s.list.unshift(a.payload); })
      .addCase(updateDepartment.fulfilled, (s, a) => {
        const idx = s.list.findIndex((d) => d.id === a.payload.id);
        if (idx !== -1) s.list[idx] = a.payload;
      })
      .addCase(deleteDepartment.fulfilled, (s, a) => {
        const ids = Array.isArray(a.payload) ? a.payload : [a.payload];
        s.list = s.list.filter((d) => !ids.includes(d.id));
      });
  },
});

export default departmentSlice.reducer;
